import * as React from "react";
import './FormVerification.css'
import {InputTypes} from "../../../components/FormStepper/InputTypes";
import FormStepper from "../../../components/FormStepper/FormStepper";
import {observer} from "mobx-react";
import FormButton from "../../../../../components/FormButton/FormButton";
import Loader from "../../../../../components/Loader/Loader";
import MixPanelAnalyticsService from "../../../../../services/Analytics/MixPanelAnalyticsService";
import {AnalyticsSignUpEvents} from "../../../../../services/Analytics/AnalyticsSignUpEvents";
import {LeadPlanType} from "shared/functions/membersApi/types/ISignupProcess";
import FormUtils from "../../../FormUtils";
import GoogleAnalyticsService from "../../../../../services/Analytics/GoogleAnalyticsService";
import {FormVerificationTexts} from "./FormVerificationTexts";


interface IProps {
    store: any;
    isLendio?: boolean
}
interface ILocalState {
    agreementSelectedOption: boolean | undefined;
}
const storePropertyName = "verification";

@observer
export default class FormVerification  extends React.Component<
    IProps,
    ILocalState
    > {
    public state: ILocalState = {
        agreementSelectedOption: undefined
    };

    public componentDidMount = () => {
        this.updateMembershipSelection();
        GoogleAnalyticsService.virtualPageView("id-verification");
    };

    public hasAgreementSelected = () => {
        const {store} = this.props;
        if(!store.isPdfSelectAllowed) {
            return;
        }
        store.formInput[storePropertyName].hasMembership = true;
        store.allowImageDelete = false;
        const newState = this.state;
        newState.agreementSelectedOption = true;
        this.setState(newState);
    };

    public noAgreementSelected = () => {
        const {store} = this.props;
        if(!store.isPdfSelectAllowed) {
            return;
        }
        MixPanelAnalyticsService.track(AnalyticsSignUpEvents.NoLease, {userInfo: store.formInput.business});
        store.allowImageDelete = false;
        store.formInput[storePropertyName].hasMembership = false;
        store.updateMembership();
        store.navigationController[storePropertyName] = store.isQuickApplication;
        const newState = this.state;
        newState.agreementSelectedOption = false;
        this.setState(newState);
    };

    public restoreAgreementSelection = () => {
        const {isLendio, store} = this.props;
        if(!isLendio) {
            const newState = this.state;
            newState.agreementSelectedOption = undefined;
            this.setState(newState);
            store.formInput.verification.hasMembership = undefined;
        }
    };

    public getAgreementOrSSNStep = () => {
        const {isLendio, store} = this.props;
        if(store.formInput.plans.plansValue === LeadPlanType.Loan) {
            return {
                title: FormVerificationTexts.titles.SSN,
                inputType: InputTypes.number,
                propName:  FormVerificationTexts.propertyNames.LEAD_SSN,
                errorLabel:  FormVerificationTexts.titles.SSN_ERROR,
                customValidationCheck: FormUtils.validate9CharactersLength,
                maxChars: 9
            }
        }else if( (this.state.agreementSelectedOption === undefined || this.state.agreementSelectedOption === false) && !store.formInput.verification.signupPdfFile && !isLendio ) {
            return (
                {
                    title: store.isQuickApplication? FormVerificationTexts.titles.AGREEMENT_TEXT_QUICK_APPLICATION : FormVerificationTexts.titles.AGREEMENT_TEXT,
                    inputType: InputTypes.boolean,
                    options: [
                        {
                            text: "Yes",
                            cta: this.hasAgreementSelected
                        },
                        {
                            text: "No",
                            cta: this.noAgreementSelected
                        }
                    ],
                    selectedOption: this.state.agreementSelectedOption,
                    propName: FormVerificationTexts.propertyNames.MEMBERSHIP
                }
            )
        }else {
            return(
                {
                    title: FormVerificationTexts.titles.LEASE_AGREEMENT,
                    inputType: InputTypes.file,
                    propName:  isLendio? FormVerificationTexts.propertyNames.LENDIO_PDF : FormVerificationTexts.propertyNames.SIGNUP_PDF,
                    allowSkip: this.state.agreementSelectedOption === undefined,
                    cb: this.restoreAgreementSelection,
                }
            )
        }

    };

    public navigateForwardAndUpdateDataIfNeeded  = () => {
        const {store} = this.props;
        GoogleAnalyticsService.triggerEvent("signup", "form submission", "verification submission");
        if(store.navigationController[storePropertyName]) {
            store.updateVerification();
            store.setIsLoading(true);
        }
    };

    public renderNextButton = () => {
        const {store} = this.props;
        const classes = store.navigationController[storePropertyName]? "blue" : "disabled";
        return <FormButton click={this.navigateForwardAndUpdateDataIfNeeded} btnText={'Next'} classes={classes}/>
    };

    public render() {
        const {store} = this.props;
        return store.isLoading? this.renderLoader() : this.renderPageContent();
    };

    private updateMembershipSelection = () => {
        const {store} = this.props;
        if(store.formInput[storePropertyName]) {
            store.formInput[storePropertyName].hasMembership = false;
        }
        store.formInput[storePropertyName] = {}
    };

    private renderLoader = () => {
        return <div> <Loader/> </div>
    };

    private  renderPageContent = () => {
        const {store} = this.props;
        return (
            <>
                <FormStepper steps={this.getVerificationPageSteps()} navigationProperty={storePropertyName} store={store}/>
                <div className="form-navigation align-right align-bottom">
                    <div className="btn-container">{this.renderNextButton()}</div>
                </div>
            </>
        )
    };

    private getVerificationPageSteps = () => {
        const {isLendio, store} = this.props;
        const verificationSteps: any = [
            {
                isHeader: true,
                title: FormVerificationTexts.titles.HEADER,
                inputType: InputTypes.none
            },
            {
                title: FormVerificationTexts.titles.ID,
                inputType: InputTypes.file,
                allowSkip: isLendio,
                propName: isLendio? FormVerificationTexts.propertyNames.LENDIO_ID : FormVerificationTexts.propertyNames.IMAGE_ID

            },
            this.getAgreementOrSSNStep(),
            {
                title: store.isQuickApplication && store.formInput.plans.plansValue === LeadPlanType.Rent?
                    FormVerificationTexts.titles.CONTACT_DESKPASS : FormVerificationTexts.titles.CONTACT,
                inputType: InputTypes.email,
                inputPlaceHolder: FormVerificationTexts.placeHolders.CONTACT,
                allowSkip: true,
                propName: FormVerificationTexts.propertyNames.CONTACT
            }
        ];
        if(store.formInput.plans.plansValue === LeadPlanType.Loan) {
            verificationSteps.pop();
        }
        return verificationSteps;
    }
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/screens/SignUpForm/FormVerification/FormVerification.tsx